// extracted by mini-css-extract-plugin
export default {"container":"search-input_container__g5bzO","icon":"search-input_icon__-f7Rc","inputContainer":"search-input_inputContainer__Fba2f","input":"search-input_input__KAtgP"};